import {
  Box,
  Button,
  Container,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Textarea,
  VStack,
  Select,
  useToast
} from "@chakra-ui/react";
import { useState } from "react";
import emailjs from "@emailjs/browser";

const Support = () => {
  const toast = useToast();

  const [game, setGame] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

 const handleSubmit = async () => {
    if (!game || !email || !message) {
      toast({
        title: "All fields are required",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      setLoading(true);

      await emailjs.send(
        "YOUR_SERVICE_ID",
        "YOUR_TEMPLATE_ID",
        {
          game: game,
          user_email: email,
          message: message,
        },
        "YOUR_PUBLIC_KEY"
      );

      toast({
        title: "Support request sent!",
        description: "We will contact you soon.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      setGame("");
      setEmail("");
      setMessage("");

    } catch (error) {
      toast({
        title: "Failed to send message",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box minH="100vh" bg="#0F0F1A" py={20}>
      <Container
        borderRadius="40px"
        p={{ base: 6, md: 12 }}
        bg="rgba(30, 10, 60, 0.55)"
        border="1px solid rgba(255,255,255,0.08)"
        boxShadow="
          inset 0 0 80px rgba(168, 85, 247, 0.1),
          0 0 120px rgba(139, 92, 246, 0.25)
        "
      >
        <Heading
          textAlign="center"
          mb={8}
          bgGradient="linear(to-r, #FFFFFF, #BDA8FB)"
          bgClip="text"
        >
          Support Form
        </Heading>

        <VStack spacing={5}>

          {/* Game Dropdown */}
          <FormControl>
            <FormLabel color="gray.300">Select Game</FormLabel>
            <Select
              placeholder="-"
              value={game}
              onChange={(e) => setGame(e.target.value)}
              bg="#20202d"
              color="gray.300"
              border="1px solid rgba(167,139,250,0.3)"
              _hover={{ borderColor: "#8B5CF6" }}
              _focus={{
                borderColor: "#8B5CF6",
                boxShadow: "0 0 0 1px #8B5CF6",
              }}
            >
              <option value="ludo">Ludo</option>
              <option value="fantasy">Fantasy Cricket</option>
              <option value="rummy">Rummy</option>
              <option value="poker">Poker</option>
            </Select>
          </FormControl>

          {/* Email */}
          <FormControl>
            <FormLabel color="gray.300">Email</FormLabel>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              color="white"
              placeholder="Enter your email"
            />
          </FormControl>

          {/* Message */}
          <FormControl>
            <FormLabel color="gray.300">Message</FormLabel>
            <Textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              color="white"
              placeholder="Describe your issue..."
            />
          </FormControl>

          {/* Submit Button */}
          <Button
            w="100%"
            bg="#8B5CF6"
            color="white"
            _hover={{ bg: "#7C3AED" }}
            onClick={handleSubmit}
            isLoading={loading}
          >
            Submit
          </Button>

        </VStack>
      </Container>
    </Box>
  );
};

export default Support;
